"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregationSignature = void 0;
const node_1 = require("../node");
const signature_1 = require("../signature");
const aggregate_types_1 = require("../../common/aggregate-types");
class AggregationSignature {
    static from(serialized) {
        let aggregation = serialized[0];
        let column = signature_1.ColumnSignature.from([serialized[1], serialized[2]]);
        return new AggregationSignature(column, aggregation);
    }
    constructor(column, aggregation) {
        this.column = column;
        this.aggregation = aggregation;
    }
    serialize() {
        return [this.aggregation].concat(this.column.serialize());
    }
}
exports.AggregationSignature = AggregationSignature;
class AggregateNode extends node_1.default {
    static from(obj) {
        if (obj['type'] === 'aggregate') {
            let aggregations = obj['aggregations'].map(AggregationSignature.from);
            return new AggregateNode(aggregations);
        }
        return null;
    }
    constructor(aggregations) {
        super('Aggregate Node');
        this.aggregations = aggregations;
    }
    checkPort(portNumber) {
        return portNumber === 0;
    }
    getSignature(datasetRepo) {
        if (!this.incoming[0])
            return null;
        return this.incoming[0].getSignature(datasetRepo);
    }
    validate(datasetRepo) {
        if (!this.incoming[0])
            return false;
        // Check that all the columns are available and the functions are valid
        let signature = this.incoming[0].getSignature(datasetRepo);
        let possibleAggTypes = Object.values(aggregate_types_1.Aggregation);
        for (let aggregation of this.aggregations) {
            if (!signature.containsColumn(aggregation.column))
                return false;
            if (!possibleAggTypes.includes(aggregation.aggregation))
                return false;
        }
        return this.incoming[0].validate(datasetRepo);
    }
    /* eslint-disable no-unused-vars */
    serialize(attributes = {}) {
        return super.serialize({
            type: 'aggregate',
            aggregations: this.aggregations.map(a => a.serialize()),
        });
    }
}
exports.default = AggregateNode;
